import { toast } from 'react-toastify';

import { withdrawUsdc } from 'api/copyBotApi';
import { useCopyBotAuth } from 'hooks';
import { store } from 'store';

export const useWithdraw = () => {
  const { account } = store.web3Store;
  const { fetchPortfolio } = store.portfolioStore;
  const { setValue, closeCopyModal } = store.copyFormStore;
  const { getAccessToken, clearAccessToken } = useCopyBotAuth();

  const withdraw = async (amountUsd: number) => {
    if (!account) return false;

    try {
      const token = await getAccessToken(account);
      await withdrawUsdc(account, { amountUsd }, token);

      toast.success('Withdrawal submitted');
      setValue('');
      closeCopyModal();
      await fetchPortfolio(true);
      return true;
    } catch (err: any) {
      if (err?.response?.status === 401) {
        clearAccessToken(account);
      }
      console.error('Failed to withdraw:', err);
      toast.error('Failed to withdraw');
      return false;
    }
  };

  return withdraw;
};
